/* import __COLOCATED_TEMPLATE__ from './categories-list-item.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import bbFrontendGlyphIconToSvg from '@banking/ui/utils/bb-frontend-glyph-icon-to-svg';
import { action } from '@ember/object';
import applyColorToSvg from '@banking/ui/utils/apply-color-to-svg';
let CategoriesListItem = (_class = class CategoriesListItem extends Component {
  get icon() {
    return this.args.category.icon ? bbFrontendGlyphIconToSvg(this.args.category.icon) : '';
  }
  get iconStyle() {
    if (this.isSelected) {
      return `
        background-color: ${this.args.category.lightModeColors?.iconBackgroundHexColor};
    `;
    } else {
      return '';
    }
  }
  get isSelected() {
    return this.args.category.categoryId === this.args.selectedCategoryId;
  }
  onInputIconAccessory(element) {
    const svgColor = this.args.category.lightModeColors?.iconTintHexColor;
    if (svgColor && this.isSelected) {
      applyColorToSvg(element.getElementsByTagName('svg')[0], svgColor);
    }
  }
  onInputCheckmarkAccessory(element) {
    const svgColor = this.args.category.lightModeColors?.checkmarkHexColor;
    if (svgColor && this.isSelected) {
      applyColorToSvg(element.getElementsByTagName('svg')[0], svgColor);
    }
  }
  onUpdateCategory() {
    this.args.onUpdateCategory({
      updatedCategoryId: this.args.category.categoryId,
      currentCategoryId: this.args.selectedCategoryId
    });
  }
}, _applyDecoratedDescriptor(_class.prototype, "onInputIconAccessory", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputIconAccessory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputCheckmarkAccessory", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputCheckmarkAccessory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onUpdateCategory", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onUpdateCategory"), _class.prototype), _class);
export { CategoriesListItem as default };